import store from '../store';

/**
 * Call API
 *
 * @param    {object}   instance  Vue instance.
 * @param    {string}   method    Axios request method.
 * @param    {string}   route     API route.
 * @param    {object}   data      API call data.
 * @param    {object}   options   API call options.
 * @returns  {Promise}  API call response.
 */
export default async (instance, method, route, data, options = {}) => {
    instance.formProcessing = true;

    // Fix for missing method while sending data via FormData instance.
    if (data instanceof FormData && ! ['get', 'post'].includes(method.toLowerCase())) {
        data.append('_method', method);
        method = 'post';
    }

    return instance.$http[method](route, data, options)
        .catch(error => {
            // Handles aborting request via cancel token.
            if (instance.$http.isCancel(error)) {
                return {
                    message: error.message,
                    isCancelled: true,
                };
            }

            if (401 === error.response.status && store.state.user) {
                store.dispatch('handleExpiredLogin');
            }

            return error.response;
        })
        .finally(() => { instance.formProcessing = false });
};
